import { MerchantAccounts, RestrictiveRelationshipsRoles } from '../shared/constants';

export const isMerchant = (role) => {
  return MerchantAccounts.includes(role);
};

export const hasRestrictiveRelationships = (role) => {
  return RestrictiveRelationshipsRoles.includes(role);
};
